// Display labels for project documents and business records.
const labels: Record<string, string> = {
  "hospitalProvince": "医院省份",
  "hospitalCity": "医院城市",
  "hospitalName": "医院名称",
  "departmentName": "科室名称",
  "name": "项目名称",
  "title": "问卷标题",
  "gender": "医生性别",
  "idCard": "医生身份证号",
  "phone": "医生联系电话",
  "phoneBindingStatus": "医生手机绑定状态",
  "bankName": "开户行",
  "bankAccount": "银行账号",
  "isDeleted": "是否删除",
  "login_password": "登录密码",
  "last_login_time": "最后登录时间",
  "wechatQrcode": "微信二维码",
  "idCardFront": "身份证正面",
  "idCardBack": "身份证反面",
  "bankCardFront": "银行卡正面",
  "titleCertificate": "职称证明照片",
  "wechat_openid": "微信OpenID",
  "wechat_nickname": "微信昵称",
  "wechat_avatar": "微信头像URL",
  "wechat_binding_time": "微信绑定时间",
  "description": "问卷说明",
  "company_name": "公司名称",
  "startDate": "项目开始日期",
  "endDate": "项目结束日期",
  "status": "生成状态",
  "manager": "项目负责人",
  "budget": "项目预算",
  "qr_code": "项目二维码标识",
  "require_login": "是否需要登录",
  "agreement_required": "是否需要签署协议",
  "agreement_title": "协议标题",
  "agreement_content": "协议内容",
  "project_type": "项目类型",
  "participation_limit_type": "参与限制周期",
  "participation_max_times": "限制周期内最大参与次数",
  "confirm_limit_per_time": "志愿者单次确认问卷份数上限",
  "level_config": "层级配置，如",
  "approval_mode": "审批模式",
  "use_role_based_approval": "是否使用基于角色的审批",
  "mobile_bg_image": "手机端问卷回答页背景图URL，为空则使用默认样式",
  "is_deleted": "是否删除",
  "type": "问卷类型",
  "questions": "问卷问题结构",
  "price": "问卷价格/劳务费",
  "createdBy": "创建人ID",
  "updatedBy": "更新人ID",
  "project_id": "项目ID",
  "survey_id": "问卷ID",
  "order": "问卷顺序",
  "is_required": "是否必填",
  "max_times": "最大填写次数，null表示不限制",
  "is_active": "是否启用",
  "user_id": "用户ID",
  "doctor_id": "医生ID",
  "answers": "答题内容",
  "created_at": "提交时间",
  "approved_by": "审批人ID",
  "approved_at": "审批时间",
  "approval_remark": "审批备注",
  "submission_type": "提交类型",
  "survey_count": "问卷数量",
  "submission_ids": "提交记录ID列表",
  "account_period": "所属账期",
  "original_amount": "原始金额总计",
  "after_tax_amount": "税后金额总计",
  "before_tax_amount": "税前金额总计",
  "tax_amount": "个人所得税金额总计",
  "settled_at": "结算时间",
  "settled_by": "结算人ID",
  "paid_at": "支付时间",
  "paid_by": "支付人ID",
  "remark": "备注",
  "historical_approved_count": "截止生成时已审核问卷总数",
  "historical_paid_count": "截止生成时已支付问卷总数",
  "admin_reject_reason": "管理员拒绝原因",
  "overall_status": "整体流程状态",
  "open_id": "微信openid",
  "signature_time": "签署时间",
  "signature_image_url": "签署图片URL",
  "ip_address": "签署时的IP地址",
  "user_agent": "签署时的浏览器信息",
  "signature_type": "签署类型",
  "labor_detail_id": "劳务明细ID",
  "signature_id": "签署记录ID",
  "file_url": "生成的劳务协议文件URL",
  "file_name": "生成的劳务协议文件名",
  "error_message": "生成失败原因",
  "generated_at": "生成时间",
  "operator_phone": "操作人手机号",
  "operator_name": "操作人姓名",
  "operator_role": "操作人角色",
  "action": "操作动作",
  "from_status": "原状态",
  "to_status": "新状态",
  "change_data": "变更数据",
  "reason": "操作原因/备注"
};
export default labels;
